<div class="main-container">
  <div class="main-message-container-content">
    <!-- <h3>Upgrade Browser</h3> -->
    <br />
    <h3>You are using an outdated version of Chrome/Edge</h3>
    <br />
    <p>
      Please update or change your browser to ensure your access to My DHL Break Bulk Site. Use
      below link to download or learn how to update your browser.
    </p>

    <div style="display: flex; gap: 40px; align-items: center">
      <a
        href="https://www.google.com/chrome/"
        target="_blank"
        title="Download Google Chrome"
        style="text-align: center; text-decoration: none; color: inherit">
        <img src="assets/images/chrome.png" alt="Download Chrome" width="64" height="64" />
        <p>Google Chrome</p>
      </a>

      <a
        href="https://www.microsoft.com/edge"
        target="_blank"
        title="Download Microsoft Edge"
        style="text-align: center; text-decoration: none; color: inherit">
        <img src="assets/images/edge.png" alt="Download Edge" width="64" height="64" />
        <p>Microsoft Edge</p>
      </a>
    </div>
  </div>
</div>
